module.exports = __webpack_public_path__ + "static/media/androidApp.6bba5898.png";